export enum CreditCardPermissions {
  Read = 'READ',
  UpdateCreditCard = 'UPDATE_CREDIT_CARD',
  Destroy = 'DESTROY',
  IssueVirtualCards = 'ISSUE_VIRTUAL_CARDS',
  IssueDelegateCreditCards = 'ISSUE_DELEGATE_CREDIT_CARDS',
  AddIntegration = 'ADD_INTEGRATION',
  RemoveIntegration = 'REMOVE_INTEGRATION',
}

export interface CreditCardPermissionsResponse {
  permissions: CreditCardPermissions[]
}

export class CreditCardPermissionsModel {
  public permissions: CreditCardPermissions[]

  public constructor(data: CreditCardPermissionsResponse) {
    this.permissions = data.permissions
  }

  public get canRead(): boolean {
    return this.permissions.includes(CreditCardPermissions.Read)
  }

  public get canUpdateCreditCard(): boolean {
    return this.permissions.includes(CreditCardPermissions.UpdateCreditCard)
  }

  public get canDestroy(): boolean {
    return this.permissions.includes(CreditCardPermissions.Destroy)
  }

  public get canIssueVirtualCards(): boolean {
    return this.permissions.includes(CreditCardPermissions.IssueVirtualCards)
  }

  public get canIssueDelegateCreditCards(): boolean {
    return this.permissions.includes(
      CreditCardPermissions.IssueDelegateCreditCards,
    )
  }
}
